export const MEDIA_SOURCE_PROFILE = "profile";
export const MEDIA_SOURCE_COMMUNICATION = "communication";
export const MEDIA_UPLOAD_NOT_VERIFIED = 0;
export const MEDIA_UPLOAD_VERIFIED = 1;

export const PHOTO_TYPE_AVATAR = "PHOTO_TYPE_AVATAR";

export const DISAPPEARING_STATUS_DEFAULT = 0;
export const DISAPPEARING_STATUS_PENDING = 1;
export const DISAPPEARING_STATUS_VIEWED = 2;
export const DISAPPEARING_STATUS_EXPIRED_USER = 3;
export const DISAPPEARING_STATUS_EXPIRED_MODEL = 4;
export const DISAPPEARING_STATUS_EXPIRED_ALL = 5;
